"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countries = void 0;
exports.countries = [
    {
        code: 'AFG',
        currencyCode: 'AFN',
        isGDPRFlagged: false,
        isoCode2: 'AF',
        isoCode3: 'AFG',
        name: 'Afghanistan',
        UUID: 'BFBBFB8C76B022582C6126859076BFCE',
    },
    {
        code: 'ALB',
        currencyCode: 'ALL',
        isGDPRFlagged: false,
        isoCode2: 'AL',
        isoCode3: 'ALB',
        name: 'Albania',
        UUID: '8401FB25C18A5E796BB47B2F202495A7',
    },
    {
        code: 'DZA',
        currencyCode: 'DZD',
        isGDPRFlagged: false,
        isoCode2: 'DZ',
        isoCode3: 'DZA',
        name: 'Algeria',
        UUID: 'F67E5D56CBF14691CEC12FF0A69272E4',
    },
    {
        code: 'ASM',
        currencyCode: 'WST',
        isGDPRFlagged: false,
        isoCode2: 'AS',
        isoCode3: 'ASM',
        name: 'American Samoa',
        UUID: '951EE57728E63C795B25E937B6CE21D9',
    },
    {
        code: 'AND',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'AD',
        isoCode3: 'AND',
        name: 'Andorra',
        UUID: '534444B859FD1CB056FDCF8FA1A11C0A',
    },
    {
        code: 'AGO',
        currencyCode: 'AOA',
        isGDPRFlagged: false,
        isoCode2: 'AO',
        isoCode3: 'AGO',
        name: 'Angola',
        UUID: 'C9589C70BE11FF62377A274A56EE1C0A',
    },
    {
        code: 'AIA',
        currencyCode: 'XCD',
        isGDPRFlagged: false,
        isoCode2: 'AI',
        isoCode3: 'AIA',
        name: 'Anguilla',
        UUID: '7A19A11D69FE57D630040EE4AE8A43CC',
    },
    {
        code: 'ATA',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'AQ',
        isoCode3: 'ATA',
        name: 'Antarctica',
        UUID: 'FEF0241BDA01C345BD8EA5CB39E46C61',
    },
    {
        code: 'ATG',
        currencyCode: 'XCD',
        isGDPRFlagged: false,
        isoCode2: 'AG',
        isoCode3: 'ATG',
        name: 'Antigua and Barbuda',
        UUID: 'BBBC6189B7539AE247D90EB324A385E5',
    },
    {
        code: 'ARG',
        currencyCode: 'ARS',
        isGDPRFlagged: false,
        isoCode2: 'AR',
        isoCode3: 'ARG',
        name: 'Argentina',
        UUID: 'D4DDA25E28F102637B3A78C8FD7D768D',
    },
    {
        code: 'ARM',
        currencyCode: 'AMD',
        isGDPRFlagged: false,
        isoCode2: 'AM',
        isoCode3: 'ARM',
        name: 'Armenia',
        UUID: 'CFB4BC23E04B27F1DF41EC9CDA5C704F',
    },
    {
        code: 'ABW',
        currencyCode: 'AWG',
        isGDPRFlagged: false,
        isoCode2: 'AW',
        isoCode3: 'ABW',
        name: 'Aruba',
        UUID: '976FC313BC5A94EE722AB7F4E92A3FAF',
    },
    {
        code: 'AUS',
        currencyCode: 'AUD',
        isGDPRFlagged: false,
        isoCode2: 'AU',
        isoCode3: 'AUS',
        name: 'Australia',
        UUID: '3B95B2767AFA41FDD4A816500A012A81',
    },
    {
        code: 'AUT',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'AT',
        isoCode3: 'AUT',
        name: 'Austria',
        UUID: '1EEDA922BF3724FDECDE9C4481643DA9',
    },
    {
        code: 'AZE',
        currencyCode: 'AZN',
        isGDPRFlagged: false,
        isoCode2: 'AZ',
        isoCode3: 'AZE',
        name: 'Azerbaijan',
        UUID: 'C66621F6F3A2DF44D1EB5CE939061BAA',
    },
    {
        code: 'BHS',
        currencyCode: 'BSD',
        isGDPRFlagged: false,
        isoCode2: 'BS',
        isoCode3: 'BHS',
        name: 'Bahamas',
        UUID: '2B6E62359A4B4BB6C0EB2DBBBA487EA6',
    },
    {
        code: 'BHR',
        currencyCode: 'BHD',
        isGDPRFlagged: false,
        isoCode2: 'BH',
        isoCode3: 'BHR',
        name: 'Bahrain',
        UUID: '2CE83B30524A4D1B11C3CE504F97C628',
    },
    {
        code: 'BGD',
        currencyCode: 'BDT',
        isGDPRFlagged: false,
        isoCode2: 'BD',
        isoCode3: 'BGD',
        name: 'Bangladesh',
        UUID: '01E545D1398A4EFD6BEE09161C7BE563',
    },
    {
        code: 'BRB',
        currencyCode: 'BBD',
        isGDPRFlagged: false,
        isoCode2: 'BB',
        isoCode3: 'BRB',
        name: 'Barbados',
        UUID: 'EE0CF3783A8A89CA9E7475F604A6DE4B',
    },
    {
        code: 'BLR',
        currencyCode: 'BYR',
        isGDPRFlagged: false,
        isoCode2: 'BY',
        isoCode3: 'BLR',
        name: 'Belarus',
        UUID: 'D9ACBD45680BA192FD4048463ADF2CD6',
    },
    {
        code: 'BEL',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'BE',
        isoCode3: 'BEL',
        name: 'Belgium',
        UUID: 'CC177EE02DB20AADED2B5D0818D78DC1',
    },
    {
        code: 'BLZ',
        currencyCode: 'BZD',
        isGDPRFlagged: false,
        isoCode2: 'BZ',
        isoCode3: 'BLZ',
        name: 'Belize',
        UUID: 'C33897F62F7970ADFC366D1B6897B16C',
    },
    {
        code: 'BEN',
        currencyCode: 'XOF',
        isGDPRFlagged: false,
        isoCode2: 'BJ',
        isoCode3: 'BEN',
        name: 'Benin',
        UUID: 'A7ECFCDF02711874CC0CF44F7015C300',
    },
    {
        code: 'BMU',
        currencyCode: 'BMD',
        isGDPRFlagged: false,
        isoCode2: 'BM',
        isoCode3: 'BMU',
        name: 'Bermuda',
        UUID: 'A38FBF34A930F60FDFAFB8A4571CF049',
    },
    {
        code: 'BTN',
        currencyCode: 'BTN',
        isGDPRFlagged: false,
        isoCode2: 'BT',
        isoCode3: 'BTN',
        name: 'Bhutan',
        UUID: 'A46E1213E192200628E4DB697419D254',
    },
    {
        code: 'BOL',
        currencyCode: 'BOB',
        isGDPRFlagged: false,
        isoCode2: 'BO',
        isoCode3: 'BOL',
        name: 'Bolivia',
        UUID: '5CFF77FAB7C257D1655BDEB26B3F0FDA',
    },
    {
        code: 'BIH',
        currencyCode: 'BAM',
        isGDPRFlagged: false,
        isoCode2: 'BA',
        isoCode3: 'BIH',
        name: 'Bosnia/Herzegowina',
        UUID: '0C8CCEBA2F60F8015D3940F45E3915A8',
    },
    {
        code: 'BWA',
        currencyCode: 'BWP',
        isGDPRFlagged: false,
        isoCode2: 'BW',
        isoCode3: 'BWA',
        name: 'Botswana',
        UUID: 'C06FC1E554674F9557283B8B39EEAAF4',
    },
    {
        code: 'BVT',
        currencyCode: 'NOK',
        isGDPRFlagged: false,
        isoCode2: 'BV',
        isoCode3: 'BVT',
        name: 'Bouvet Island',
        UUID: 'A2747C1D0276A0F25C138E8129A94F87',
    },
    {
        code: 'BRA',
        currencyCode: 'BRL',
        isGDPRFlagged: false,
        isoCode2: 'BR',
        isoCode3: 'BRA',
        name: 'Brazil',
        UUID: '717842C549DDB29AB4B6D52A1A241CBC',
    },
    {
        code: 'IOT',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'IO',
        isoCode3: 'IOT',
        name: 'British Indian Ocean Territory',
        UUID: '782E927B327970B68204394B50ABFA68',
    },
    {
        code: 'BRN',
        currencyCode: 'BND',
        isGDPRFlagged: false,
        isoCode2: 'BN',
        isoCode3: 'BRN',
        name: 'Brunei',
        UUID: 'D118E94DAC05643CFCB9155B01FD0D83',
    },
    {
        code: 'BGR',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'BG',
        isoCode3: 'BGR',
        name: 'Bulgaria',
        UUID: '666B007DCC10D43DBBD412B53DDF386B',
    },
    {
        code: 'BFA',
        currencyCode: 'XOF',
        isGDPRFlagged: false,
        isoCode2: 'BF',
        isoCode3: 'BFA',
        name: 'Burkina Faso',
        UUID: 'BF7D408C22BBDBAD0CAEBBCF794CC2DB',
    },
    {
        code: 'BDI',
        currencyCode: 'BIF',
        isGDPRFlagged: false,
        isoCode2: 'BI',
        isoCode3: 'BDI',
        name: 'Burundi',
        UUID: '242F163F90274096E6139537526F9C62',
    },
    {
        code: 'KHM',
        currencyCode: 'KHR',
        isGDPRFlagged: false,
        isoCode2: 'KH',
        isoCode3: 'KHM',
        name: 'Cambodia',
        UUID: '2F3259F5918AE8AAB6F348F2008C1C20',
    },
    {
        code: 'CMR',
        currencyCode: 'XAF',
        isGDPRFlagged: false,
        isoCode2: 'CM',
        isoCode3: 'CMR',
        name: 'Cameroon',
        UUID: 'F7DAA024596DC9AEBD29701B19D8284D',
    },
    {
        code: 'CAN',
        currencyCode: 'CAD',
        isGDPRFlagged: false,
        isoCode2: 'CA',
        isoCode3: 'CAN',
        name: 'Canada',
        UUID: '9DCB4F796D0C3174735DD42E312EC996',
    },
    {
        code: 'CPV',
        currencyCode: 'CVE',
        isGDPRFlagged: false,
        isoCode2: 'CV',
        isoCode3: 'CPV',
        name: 'Cape Verde',
        UUID: '8665E6ED44ED3EC38CEFF75C9824E4AD',
    },
    {
        code: 'CYM',
        currencyCode: 'KYD',
        isGDPRFlagged: false,
        isoCode2: 'KY',
        isoCode3: 'CYM',
        name: 'Cayman Islands',
        UUID: 'EA4DDE840696D888DD35BA40B6304825',
    },
    {
        code: 'CAF',
        currencyCode: 'XAF',
        isGDPRFlagged: false,
        isoCode2: 'CF',
        isoCode3: 'CAF',
        name: 'Central African Republic',
        UUID: 'E7FFB2D2D51A41AA283BAE60856D0E64',
    },
    {
        code: 'TCD',
        currencyCode: 'XAF',
        isGDPRFlagged: false,
        isoCode2: 'TD',
        isoCode3: 'TCD',
        name: 'Chad',
        UUID: '6C8556E4486DE1FE18B73C58AB15D42A',
    },
    {
        code: 'CHL',
        currencyCode: 'CLP',
        isGDPRFlagged: false,
        isoCode2: 'CL',
        isoCode3: 'CHL',
        name: 'Chile',
        UUID: '6C2406713CDF20D4C9393F646ECFEA15',
    },
    {
        code: 'CHN',
        currencyCode: 'CNY',
        isGDPRFlagged: false,
        isoCode2: 'CN',
        isoCode3: 'CHN',
        name: 'China',
        UUID: 'B185C715A16917C192EA043304B8D051',
    },
    {
        code: 'CXR',
        currencyCode: 'AUD',
        isGDPRFlagged: false,
        isoCode2: 'CX',
        isoCode3: 'CXR',
        name: 'Christmas Island',
        UUID: '27F97056FEB07F8908133CE7122FD9AF',
    },
    {
        code: 'CCK',
        currencyCode: 'AUD',
        isGDPRFlagged: false,
        isoCode2: 'CC',
        isoCode3: 'CCK',
        name: 'Cocos Islands',
        UUID: '1853A07C1B13978356E05AF297A31EA8',
    },
    {
        code: 'COL',
        currencyCode: 'COP',
        isGDPRFlagged: false,
        isoCode2: 'CO',
        isoCode3: 'COL',
        name: 'Colombia',
        UUID: 'BBE1DDE30D4B69DBA569E73628F2AE46',
    },
    {
        code: 'COM',
        currencyCode: 'KMF',
        isGDPRFlagged: false,
        isoCode2: 'KM',
        isoCode3: 'COM',
        name: 'Comoros',
        UUID: '21191349B8C0B81E89EF141D73C431D6',
    },
    {
        code: 'COG',
        currencyCode: 'CDF',
        isGDPRFlagged: false,
        isoCode2: 'CG',
        isoCode3: 'COG',
        name: 'Republic of the Congo',
        UUID: '953714CB9B8A8F80C540D073E671BC11',
    },
    {
        code: 'COD',
        currencyCode: 'CDF',
        isGDPRFlagged: false,
        isoCode2: 'CD',
        isoCode3: 'COD',
        name: 'Democratic Republic of the Congo',
        UUID: 'B1641863CC9E750F7F414B5937249400',
    },
    {
        code: 'COK',
        currencyCode: 'NZD',
        isGDPRFlagged: false,
        isoCode2: 'CK',
        isoCode3: 'COK',
        name: 'Cook Islands',
        UUID: 'EB3EAAD248903BEF1129FD4799F5FC32',
    },
    {
        code: 'CRI',
        currencyCode: 'CRC',
        isGDPRFlagged: false,
        isoCode2: 'CR',
        isoCode3: 'CRI',
        name: 'Costa Rica',
        UUID: 'B6EB0C484783D06E62E00B28D96AE838',
    },
    {
        code: 'HRV',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'HR',
        isoCode3: 'HRV',
        name: 'Croatia',
        UUID: 'D5E889215DB4E772F18CCD8AE342A1BF',
    },
    {
        code: 'CUB',
        currencyCode: 'CUP',
        isGDPRFlagged: false,
        isoCode2: 'CU',
        isoCode3: 'CUB',
        name: 'Cuba',
        UUID: '85C60CF32DEFCB7922ADF399B9E961C2',
    },
    {
        code: 'CYP',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'CY',
        isoCode3: 'CYP',
        name: 'Cyprus',
        UUID: 'F2A46A22D2AA6EC9E72544645CD44181',
    },
    {
        code: 'CZE',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'CZ',
        isoCode3: 'CZE',
        name: 'Czech Republic',
        UUID: '07CE542CF7BBC7BCCB9DDD49C41F89EF',
    },
    {
        code: 'DNK',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'DK',
        isoCode3: 'DNK',
        name: 'Denmark',
        UUID: '542FB67733E132DF3A6A470F02FAEFE0',
    },
    {
        code: 'DJI',
        currencyCode: 'DJF',
        isGDPRFlagged: false,
        isoCode2: 'DJ',
        isoCode3: 'DJI',
        name: 'Djibouti',
        UUID: 'E3C85E8171E6E779AE505E5E9D8A6E91',
    },
    {
        code: 'DMA',
        currencyCode: 'XCD',
        isGDPRFlagged: false,
        isoCode2: 'DM',
        isoCode3: 'DMA',
        name: 'Dominica',
        UUID: '247717FC702F95D65F271CC49B575E71',
    },
    {
        code: 'DOM',
        currencyCode: 'DOP',
        isGDPRFlagged: false,
        isoCode2: 'DO',
        isoCode3: 'DOM',
        name: 'Dominican Republic',
        UUID: 'F36D0BC1EB1E074D8ECF22B431AEDEAF',
    },
    {
        code: 'TMP',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'TP',
        isoCode3: 'TMP',
        name: 'East Timor',
        UUID: '77F20DB6A704BD2FA289535024187AF1',
    },
    {
        code: 'ECU',
        currencyCode: 'ECS',
        isGDPRFlagged: false,
        isoCode2: 'EC',
        isoCode3: 'ECU',
        name: 'Ecuador',
        UUID: 'BA2137D319A463F91D4D11DC1797F109',
    },
    {
        code: 'EGY',
        currencyCode: 'EGP',
        isGDPRFlagged: false,
        isoCode2: 'EG',
        isoCode3: 'EGY',
        name: 'Egypt',
        UUID: '11FFDB1D9CACCC8B5EB3621A34D32DF8',
    },
    {
        code: 'SLV',
        currencyCode: 'SVC',
        isGDPRFlagged: false,
        isoCode2: 'SV',
        isoCode3: 'SLV',
        name: 'El Salvador',
        UUID: 'FCA8BFC8ABBAE7EB24B6832D072BBD60',
    },
    {
        code: 'GNQ',
        currencyCode: 'XAF',
        isGDPRFlagged: false,
        isoCode2: 'GQ',
        isoCode3: 'GNQ',
        name: 'Equatorial Guinea',
        UUID: '92F64619414D269A1C04A32E63312462',
    },
    {
        code: 'ERI',
        currencyCode: 'ERN',
        isGDPRFlagged: false,
        isoCode2: 'ER',
        isoCode3: 'ERI',
        name: 'Eritrea',
        UUID: '938B093A26A324EF9354D700BF680294',
    },
    {
        code: 'EST',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'EE',
        isoCode3: 'EST',
        name: 'Estonia',
        UUID: '7E5BDD27E44E554738432DE58620F7EF',
    },
    {
        code: 'ETH',
        currencyCode: 'ETB',
        isGDPRFlagged: false,
        isoCode2: 'ET',
        isoCode3: 'ETH',
        name: 'Ethiopia',
        UUID: '14DABD19448F822E2B257BF473FACA03',
    },
    {
        code: 'FLK',
        currencyCode: 'FKP',
        isGDPRFlagged: false,
        isoCode2: 'FK',
        isoCode3: 'FLK',
        name: 'Falkland Islands',
        UUID: 'DA973D633CBA079C0394322DA4FFF880',
    },
    {
        code: 'FRO',
        currencyCode: 'DKK',
        isGDPRFlagged: false,
        isoCode2: 'FO',
        isoCode3: 'FRO',
        name: 'Faroe Islands',
        UUID: '79CDC6E6AA51F64C94250FB24F2E3FB9',
    },
    {
        code: 'FJI',
        currencyCode: 'FJD',
        isGDPRFlagged: false,
        isoCode2: 'FJ',
        isoCode3: 'FJI',
        name: 'Fiji',
        UUID: 'FF31A38B3D43B883A665594FA6C1029E',
    },
    {
        code: 'FIN',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'FI',
        isoCode3: 'FIN',
        name: 'Finland',
        UUID: 'B76D6256C2095739D8497A9CA7823A02',
    },
    {
        code: 'FRA',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'FR',
        isoCode3: 'FRA',
        name: 'France',
        UUID: '71D00C86444D19C687E66DF521EA4EB8',
    },
    {
        code: 'GUF',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'GF',
        isoCode3: 'GUF',
        name: 'French Guiana',
        UUID: '6D792B00FD3D0023A49395B83EE4ADDC',
    },
    {
        code: 'PYF',
        currencyCode: 'XPF',
        isGDPRFlagged: false,
        isoCode2: 'PF',
        isoCode3: 'PYF',
        name: 'French Polynesia',
        UUID: '98E40B9C07A84D1FE414FDF2247925B7',
    },
    {
        code: 'ATF',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'TF',
        isoCode3: 'ATF',
        name: 'French Southern Territories',
        UUID: '851FCF853D065E03A08F9CB72D42276E',
    },
    {
        code: 'GAB',
        currencyCode: 'XAF',
        isGDPRFlagged: false,
        isoCode2: 'GA',
        isoCode3: 'GAB',
        name: 'Gabon',
        UUID: 'BC06FD5693D82ED8102E3B4A7126148E',
    },
    {
        code: 'GMB',
        currencyCode: 'GMD',
        isGDPRFlagged: false,
        isoCode2: 'GM',
        isoCode3: 'GMB',
        name: 'Gambia',
        UUID: 'A94C86B89FB165DFC8251472D168DD9C',
    },
    {
        code: 'GEO',
        currencyCode: 'GEL',
        isGDPRFlagged: false,
        isoCode2: 'GE',
        isoCode3: 'GEO',
        name: 'Georgia',
        UUID: '52A85701F6A8A2164C6812F7D966246C',
    },
    {
        code: 'DEU',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'DE',
        isoCode3: 'DEU',
        name: 'Germany',
        UUID: 'FE7ED263C418EB3B66DE852555DE170F',
    },
    {
        code: 'GHA',
        currencyCode: 'GHS',
        isGDPRFlagged: false,
        isoCode2: 'GH',
        isoCode3: 'GHA',
        name: 'Ghana',
        UUID: '6B9A29F88B7189A76BDC2D700F67E7AE',
    },
    {
        code: 'GIB',
        currencyCode: 'GIP',
        isGDPRFlagged: false,
        isoCode2: 'GI',
        isoCode3: 'GIB',
        name: 'Gibraltar',
        UUID: 'C0C8C961FA3F5578559A3224855F16EF',
    },
    {
        code: 'GRC',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'GR',
        isoCode3: 'GRC',
        name: 'Greece',
        UUID: '1A9607F07D42182D3E083763FC02B343',
    },
    {
        code: 'GRL',
        currencyCode: 'DKK',
        isGDPRFlagged: false,
        isoCode2: 'GL',
        isoCode3: 'GRL',
        name: 'Greenland',
        UUID: 'B8597409C9969FDA284F5CE5F7B6015F',
    },
    {
        code: 'GRD',
        currencyCode: 'XCD',
        isGDPRFlagged: false,
        isoCode2: 'GD',
        isoCode3: 'GRD',
        name: 'Grenada',
        UUID: '3DDED1DC54CFF40B3A319AF49BDBED2A',
    },
    {
        code: 'GLP',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'GP',
        isoCode3: 'GLP',
        name: 'Guadeloupe',
        UUID: 'A637AAAB4038AE591A8EF89569DEE44F',
    },
    {
        code: 'GUM',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'GU',
        isoCode3: 'GUM',
        name: 'Guam',
        UUID: 'B0A47CE9745DD5914F6FAAF8717E1E50',
    },
    {
        code: 'GTM',
        currencyCode: 'GTQ',
        isGDPRFlagged: false,
        isoCode2: 'GT',
        isoCode3: 'GTM',
        name: 'Guatemala',
        UUID: '88129185BF3BC24B6E16BC0C230EE93B',
    },
    {
        code: 'GIN',
        currencyCode: 'GNF',
        isGDPRFlagged: false,
        isoCode2: 'GN',
        isoCode3: 'GIN',
        name: 'Guinea',
        UUID: '5C36377E1B80735334C57A155A3EED14',
    },
    {
        code: 'GNB',
        currencyCode: 'XOF',
        isGDPRFlagged: false,
        isoCode2: 'GW',
        isoCode3: 'GNB',
        name: 'Guinea-Bissau',
        UUID: '694FE5B0638C331224BC55E788806120',
    },
    {
        code: 'GUY',
        currencyCode: 'GYD',
        isGDPRFlagged: false,
        isoCode2: 'GY',
        isoCode3: 'GUY',
        name: 'Guyana',
        UUID: '73FA322894A253AAD39CE125A540CE60',
    },
    {
        code: 'HTI',
        currencyCode: 'HTG',
        isGDPRFlagged: false,
        isoCode2: 'HT',
        isoCode3: 'HTI',
        name: 'Haiti',
        UUID: '9F76C9BE43C21BA857C184A2D7457B7D',
    },
    {
        code: 'HMD',
        currencyCode: 'AUD',
        isGDPRFlagged: false,
        isoCode2: 'HM',
        isoCode3: 'HMD',
        name: 'Heard/McDonald Islands',
        UUID: '1599E22B14D88B07AA903F06CCC45384',
    },
    {
        code: 'HND',
        currencyCode: 'HNL',
        isGDPRFlagged: false,
        isoCode2: 'HN',
        isoCode3: 'HND',
        name: 'Honduras',
        UUID: '246B24F9351BEB51D4D96CC84B6EEED2',
    },
    {
        code: 'HKG',
        currencyCode: 'HKD',
        isGDPRFlagged: false,
        isoCode2: 'HK',
        isoCode3: 'HKG',
        name: 'Hong Kong',
        UUID: 'EBFA861CF5909090864EC68CBD4665D2',
    },
    {
        code: 'HUN',
        currencyCode: 'EUR',
        isGDPRFlagged: true,
        isoCode2: 'HU',
        isoCode3: 'HUN',
        name: 'Hungary',
        UUID: '08E8D03FDE63BE2A7DA8610EC4812C02',
    },
    {
        code: 'ISL',
        currencyCode: 'ISK',
        isGDPRFlagged: false,
        isoCode2: 'IS',
        isoCode3: 'ISL',
        name: 'Iceland',
        UUID: '3C1CE899D03894622CC4847B6BC0BBEE',
    },
    {
        code: 'IND',
        currencyCode: 'INR',
        isGDPRFlagged: false,
        isoCode2: 'IN',
        isoCode3: 'IND',
        name: 'India',
        UUID: '9DD14A17651C55B63C353600E8A825C2',
    },
    {
        code: 'IDN',
        currencyCode: 'IDR',
        isGDPRFlagged: false,
        isoCode2: 'ID',
        isoCode3: 'IDN',
        name: 'Indonesia',
        UUID: 'A282F318E2777A56E3D39F25CCC56D45',
    },
    {
        code: 'IRN',
        currencyCode: 'IRR',
        isGDPRFlagged: false,
        isoCode2: 'IR',
        isoCode3: 'IRN',
        name: 'Iran',
        UUID: '876074ADB671A2685D91004C372E1255',
    },
    {
        code: 'IRQ',
        currencyCode: 'IQD',
        isGDPRFlagged: false,
        isoCode2: 'IQ',
        isoCode3: 'IRQ',
        name: 'Iraq',
        UUID: 'D1A9DEF163C754D28794675860139EDB',
    },
    {
        code: 'IRL',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'IE',
        isoCode3: 'IRL',
        name: 'Ireland',
        UUID: '01A79D3E27BE03CC84E4D441FC69BA88',
    },
    {
        code: 'ISR',
        currencyCode: 'ILS',
        isGDPRFlagged: false,
        isoCode2: 'IL',
        isoCode3: 'ISR',
        name: 'Israel',
        UUID: '31137E382D78D2FC6BA42A865B83C216',
    },
    {
        code: 'ITA',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'IT',
        isoCode3: 'ITA',
        name: 'Italy',
        UUID: '1A1567ACA73C09743B1E35D4F19D21A0',
    },
    {
        code: 'JAM',
        currencyCode: 'JMD',
        isGDPRFlagged: false,
        isoCode2: 'JM',
        isoCode3: 'JAM',
        name: 'Jamaica',
        UUID: 'D26AFCB3C5307BB71BD5EBBE426247CF',
    },
    {
        code: 'JPN',
        currencyCode: 'JPY',
        isGDPRFlagged: false,
        isoCode2: 'JP',
        isoCode3: 'JPN',
        name: 'Japan',
        UUID: '76D6DDE1CA7A4A58D4D77065629F0403',
    },
    {
        code: 'JOR',
        currencyCode: 'JOD',
        isGDPRFlagged: false,
        isoCode2: 'JO',
        isoCode3: 'JOR',
        name: 'Jordan',
        UUID: '2CD7F2AB70DB5142F1E24EB83F94BBE4',
    },
    {
        code: 'KAZ',
        currencyCode: 'KZT',
        isGDPRFlagged: false,
        isoCode2: 'KZ',
        isoCode3: 'KAZ',
        name: 'Kazakhstan',
        UUID: '24A0A9125B2FAE5BAC4046C897FF16C0',
    },
    {
        code: 'KEN',
        currencyCode: 'KES',
        isGDPRFlagged: false,
        isoCode2: 'KE',
        isoCode3: 'KEN',
        name: 'Kenya',
        UUID: '031FDF56CED5ADC537AE8FED9BE17DD6',
    },
    {
        code: 'KIR',
        currencyCode: 'AUD',
        isGDPRFlagged: false,
        isoCode2: 'KI',
        isoCode3: 'KIR',
        name: 'Kiribati',
        UUID: '1D1BC3D3286283680AE56B6DFB301587',
    },
    {
        code: 'KOR',
        currencyCode: 'KRW',
        isGDPRFlagged: false,
        isoCode2: 'KR',
        isoCode3: 'KOR',
        name: 'Korea Republic',
        UUID: '5A1C3E90DF1242E9E52B58D02BD62C2F',
    },
    {
        code: 'KWT',
        currencyCode: 'KWD',
        isGDPRFlagged: false,
        isoCode2: 'KW',
        isoCode3: 'KWT',
        name: 'Kuwait',
        UUID: '9F3A332A7666684924A4CBA53CF122EA',
    },
    {
        code: 'KGZ',
        currencyCode: 'KGS',
        isGDPRFlagged: false,
        isoCode2: 'KG',
        isoCode3: 'KGZ',
        name: 'Kyrgyzstan',
        UUID: 'B5268758DCAC9B6E59F5174EE3EF583C',
    },
    {
        code: 'LVA',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'LV',
        isoCode3: 'LVA',
        name: 'Latvia',
        UUID: '7B894D71A817C31CE303696F03ECCB15',
    },
    {
        code: 'LBN',
        currencyCode: 'LBP',
        isGDPRFlagged: false,
        isoCode2: 'LB',
        isoCode3: 'LBN',
        name: 'Lebanon',
        UUID: 'BEA97B5DF30725393FFAE165A5A00276',
    },
    {
        code: 'LSO',
        currencyCode: 'LSL',
        isGDPRFlagged: false,
        isoCode2: 'LS',
        isoCode3: 'LSO',
        name: 'Lesotho',
        UUID: '298CC8540298DE95D9EB2CE5D86E0A5C',
    },
    {
        code: 'LBR',
        currencyCode: 'LRD',
        isGDPRFlagged: false,
        isoCode2: 'LR',
        isoCode3: 'LBR',
        name: 'Liberia',
        UUID: '83017B3C2667B50F20E182E239FAF4AB',
    },
    {
        code: 'LBY',
        currencyCode: 'LYD',
        isGDPRFlagged: false,
        isoCode2: 'LY',
        isoCode3: 'LBY',
        name: 'Libyan Arab Jamahiriya',
        UUID: '64F86931079A560A023EC2BC1B10F6D8',
    },
    {
        code: 'LIE',
        currencyCode: 'CHF',
        isGDPRFlagged: false,
        isoCode2: 'LI',
        isoCode3: 'LIE',
        name: 'Liechtenstein',
        UUID: '1B2593C6A30E92DFD4F427D5ADD86BBD',
    },
    {
        code: 'LTU',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'LT',
        isoCode3: 'LTU',
        name: 'Lithuania',
        UUID: '2BB3CA16DA5C780E15EE8F4C27BC7F9C',
    },
    {
        code: 'LUX',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'LU',
        isoCode3: 'LUX',
        name: 'Luxembourg',
        UUID: '5BCC7F380307434A05AA680F86B1462A',
    },
    {
        code: 'MAC',
        currencyCode: 'MOP',
        isGDPRFlagged: false,
        isoCode2: 'MO',
        isoCode3: 'MAC',
        name: 'Macau',
        UUID: '61220A2FF7DC6B9F699E153292CDAA8F',
    },
    {
        code: 'MKD',
        currencyCode: 'MKD',
        isGDPRFlagged: false,
        isoCode2: 'MK',
        isoCode3: 'MKD',
        name: 'Macedonia',
        UUID: '90177AEC344147846CD76E07D5801C67',
    },
    {
        code: 'MDG',
        currencyCode: 'MGA',
        isGDPRFlagged: false,
        isoCode2: 'MG',
        isoCode3: 'MDG',
        name: 'Madagascar',
        UUID: '1C0602B5F5C3BFDE19D9DF611F2AFCB5',
    },
    {
        code: 'MWI',
        currencyCode: 'MWK',
        isGDPRFlagged: false,
        isoCode2: 'MW',
        isoCode3: 'MWI',
        name: 'Malawi',
        UUID: '1943E7A0437ABD08E43B86EDEE336EF4',
    },
    {
        code: 'MYS',
        currencyCode: 'MYR',
        isGDPRFlagged: false,
        isoCode2: 'MY',
        isoCode3: 'MYS',
        name: 'Malaysia',
        UUID: '744D35B896F57EF5E5F1DB13C2AB63AB',
    },
    {
        code: 'MDV',
        currencyCode: 'MVR',
        isGDPRFlagged: false,
        isoCode2: 'MV',
        isoCode3: 'MDV',
        name: 'Maldives',
        UUID: 'F56493B0132AAC1A871CD749AB1E1EAE',
    },
    {
        code: 'MLI',
        currencyCode: 'XOF',
        isGDPRFlagged: false,
        isoCode2: 'ML',
        isoCode3: 'MLI',
        name: 'Mali',
        UUID: '132EE6CB4BEFA5E5F15BE5A0D8078B5C',
    },
    {
        code: 'MLT',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'MT',
        isoCode3: 'MLT',
        name: 'Malta',
        UUID: 'B67E1C84E2D73F0A666C785A94538DA0',
    },
    {
        code: 'MHL',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'MH',
        isoCode3: 'MHL',
        name: 'Marshall Islands',
        UUID: '088CBFB98B9F7AABC5C733D30827E7B6',
    },
    {
        code: 'MTQ',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'MQ',
        isoCode3: 'MTQ',
        name: 'Martinique',
        UUID: 'AAE1A93A96E680F68E19239D6D68835A',
    },
    {
        code: 'MRT',
        currencyCode: 'MRO',
        isGDPRFlagged: false,
        isoCode2: 'MR',
        isoCode3: 'MRT',
        name: 'Mauritania',
        UUID: '174ADB99D8EFAFDB5B611F43ED7885F1',
    },
    {
        code: 'MUS',
        currencyCode: 'MUR',
        isGDPRFlagged: false,
        isoCode2: 'MU',
        isoCode3: 'MUS',
        name: 'Mauritius',
        UUID: 'AA0BAB7681F04CD7C23AF33BFFC456F3',
    },
    {
        code: 'MYT',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'YT',
        isoCode3: 'MYT',
        name: 'Mayotte',
        UUID: 'F96C2340D52B55D7BCD38B380A4A0286',
    },
    {
        code: 'MEX',
        currencyCode: 'MXN',
        isGDPRFlagged: false,
        isoCode2: 'MX',
        isoCode3: 'MEX',
        name: 'Mexico',
        UUID: 'A02C48639304E5FA3A80022295DD7ED1',
    },
    {
        code: 'FSM',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'FM',
        isoCode3: 'FSM',
        name: 'Micronesia',
        UUID: 'EA0B4387EDCD7C8CAD44EBF5C66D78A2',
    },
    {
        code: 'MDA',
        currencyCode: 'MDL',
        isGDPRFlagged: false,
        isoCode2: 'MD',
        isoCode3: 'MDA',
        name: 'Moldova',
        UUID: 'A0A0B0DA622D66E1F22A4A39FE5257C8',
    },
    {
        code: 'MCO',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'MC',
        isoCode3: 'MCO',
        name: 'Monaco',
        UUID: 'F73202DA535512504241E89F8FDE62AA',
    },
    {
        code: 'MNG',
        currencyCode: 'MNT',
        isGDPRFlagged: false,
        isoCode2: 'MN',
        isoCode3: 'MNG',
        name: 'Mongolia',
        UUID: '9151D7AA89E2F148CF52F783AD16EF7E',
    },
    {
        code: 'MSR',
        currencyCode: 'XCD',
        isGDPRFlagged: false,
        isoCode2: 'MS',
        isoCode3: 'MSR',
        name: 'Montserrat',
        UUID: 'E860B9C68CE5C9CFFBB2168EB5CA9DC4',
    },
    {
        code: 'MAR',
        currencyCode: 'MAD',
        isGDPRFlagged: false,
        isoCode2: 'MA',
        isoCode3: 'MAR',
        name: 'Morocco',
        UUID: '582F563BBA7E0EF2764A2ACBFAB5778D',
    },
    {
        code: 'MOZ',
        currencyCode: 'MZN',
        isGDPRFlagged: false,
        isoCode2: 'MZ',
        isoCode3: 'MOZ',
        name: 'Mozambique',
        UUID: 'A8B80B3390A413354C0DC294422637E2',
    },
    {
        code: 'MMR',
        currencyCode: 'MMK',
        isGDPRFlagged: false,
        isoCode2: 'MM',
        isoCode3: 'MMR',
        name: 'Myanmar',
        UUID: '0B8DC36E01C450485E6678BA36C86F3F',
    },
    {
        code: 'NAM',
        currencyCode: 'NAD',
        isGDPRFlagged: false,
        isoCode2: 'NA',
        isoCode3: 'NAM',
        name: 'Namibia',
        UUID: '6801116EAF764A03856A2ECC0EB22039',
    },
    {
        code: 'NRU',
        currencyCode: 'AUD',
        isGDPRFlagged: false,
        isoCode2: 'NR',
        isoCode3: 'NRU',
        name: 'Nauru',
        UUID: 'DB37CB3AA1B2667470018D99C28DA034',
    },
    {
        code: 'NPL',
        currencyCode: 'NPR',
        isGDPRFlagged: false,
        isoCode2: 'NP',
        isoCode3: 'NPL',
        name: 'Nepal',
        UUID: '75209AE6C491D400F0119566CABC66C7',
    },
    {
        code: 'NLD',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'NL',
        isoCode3: 'NLD',
        name: 'Netherlands',
        UUID: 'C53F98F42F5FF91769B5B14F4578B488',
    },
    {
        code: 'ANT',
        currencyCode: 'ANG',
        isGDPRFlagged: false,
        isoCode2: 'AN',
        isoCode3: 'ANT',
        name: 'Netherlands Antilles',
        UUID: 'B9FFF571DC9E93AA612F5EF08CF74847',
    },
    {
        code: '',
        currencyCode: '',
        isGDPRFlagged: false,
        isoCode2: 'NT',
        isoCode3: 'NTZ',
        name: 'Neutral Zone',
        UUID: 'B7F7A9D33DF65FD71BE5C9EB45B1887B',
    },
    {
        code: 'NCL',
        currencyCode: 'XPF',
        isGDPRFlagged: false,
        isoCode2: 'NC',
        isoCode3: 'NCL',
        name: 'New Caledonia',
        UUID: '5ED2EE6888EEDDC11300E5ABA7A9BA39',
    },
    {
        code: 'NZL',
        currencyCode: 'NZD',
        isGDPRFlagged: false,
        isoCode2: 'NZ',
        isoCode3: 'NZL',
        name: 'New Zealand',
        UUID: '1BF6B4A19CB6C26E1F9D557FC471EBC9',
    },
    {
        code: 'NIC',
        currencyCode: 'NIO',
        isGDPRFlagged: false,
        isoCode2: 'NI',
        isoCode3: 'NIC',
        name: 'Nicaragua',
        UUID: '64CE8991A312F4CE541CD5315E34C60E',
    },
    {
        code: 'NER',
        currencyCode: 'XOF',
        isGDPRFlagged: false,
        isoCode2: 'NE',
        isoCode3: 'NER',
        name: 'Niger',
        UUID: '2EBAF9D331FA67F2BF401926AD1F29C0',
    },
    {
        code: 'NGA',
        currencyCode: 'NGN',
        isGDPRFlagged: false,
        isoCode2: 'NG',
        isoCode3: 'NGA',
        name: 'Nigeria',
        UUID: 'E6B12E20B4B9C13B22808CCC3F4A4AE7',
    },
    {
        code: 'NIU',
        currencyCode: 'NZD',
        isGDPRFlagged: false,
        isoCode2: 'NU',
        isoCode3: 'NIU',
        name: 'Niue',
        UUID: '2FB34D4D414DC71B690AE3DE41A69381',
    },
    {
        code: 'NFK',
        currencyCode: 'AUD',
        isGDPRFlagged: false,
        isoCode2: 'NF',
        isoCode3: 'NFK',
        name: 'Norfolk Island',
        UUID: '31593F0BB0017777552D9956E5CBCE17',
    },
    {
        code: 'MNP',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'MP',
        isoCode3: 'MNP',
        name: 'Northern Mariana Islands',
        UUID: '6DF4320A10C8E212D139FD21BE1E4607',
    },
    {
        code: 'NOR',
        currencyCode: 'NOK',
        isGDPRFlagged: false,
        isoCode2: 'NO',
        isoCode3: 'NOR',
        name: 'Norway',
        UUID: '93E7C1105E05F5FB0992B304557749EF',
    },
    {
        code: 'OMN',
        currencyCode: 'OMR',
        isGDPRFlagged: false,
        isoCode2: 'OM',
        isoCode3: 'OMN',
        name: 'Oman',
        UUID: '95D412A421C218B322EF59854FCB5B44',
    },
    {
        code: 'PAK',
        currencyCode: 'PKR',
        isGDPRFlagged: false,
        isoCode2: 'PK',
        isoCode3: 'PAK',
        name: 'Pakistan',
        UUID: '7D5CBA7C56399766B8411B92BE2AF323',
    },
    {
        code: 'PLW',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'PW',
        isoCode3: 'PLW',
        name: 'Palau',
        UUID: 'AB8318EC24231EEB55CD1622DF2BC674',
    },
    {
        code: 'PSE',
        currencyCode: 'JOD',
        isGDPRFlagged: false,
        isoCode2: 'PS',
        isoCode3: 'PSE',
        name: 'Palestine',
        UUID: '1C244AE0118B6DD10F27AC4D17177421',
    },
    {
        code: 'PAN',
        currencyCode: 'PAB',
        isGDPRFlagged: false,
        isoCode2: 'PA',
        isoCode3: 'PAN',
        name: 'Panama',
        UUID: '860D0CA910D6AF26B6974BD9AEE6DDFB',
    },
    {
        code: 'PNG',
        currencyCode: 'PGK',
        isGDPRFlagged: false,
        isoCode2: 'PG',
        isoCode3: 'PNG',
        name: 'Papua New Guinea',
        UUID: 'E353715F85819FD9BA48B04E2E4152A2',
    },
    {
        code: 'PRY',
        currencyCode: 'PYG',
        isGDPRFlagged: false,
        isoCode2: 'PY',
        isoCode3: 'PRY',
        name: 'Paraguay',
        UUID: '6685B66C0CC59F77AE8D134F742080E1',
    },
    {
        code: 'PER',
        currencyCode: 'PEN',
        isGDPRFlagged: false,
        isoCode2: 'PE',
        isoCode3: 'PER',
        name: 'Peru',
        UUID: 'C4EC1F367489DD1C9AE10D3C69FA7D68',
    },
    {
        code: 'PHL',
        currencyCode: 'PHP',
        isGDPRFlagged: false,
        isoCode2: 'PH',
        isoCode3: 'PHL',
        name: 'Philippines',
        UUID: '62B95BBFC153F9D6A2333118F6A8D15D',
    },
    {
        code: 'PCN',
        currencyCode: 'NZD',
        isGDPRFlagged: false,
        isoCode2: 'PN',
        isoCode3: 'PCN',
        name: 'Pitcairn Islands',
        UUID: '24878B26E2493CF065AC975DF52F4B88',
    },
    {
        code: 'POL',
        currencyCode: 'EUR',
        isGDPRFlagged: true,
        isoCode2: 'PL',
        isoCode3: 'POL',
        name: 'Poland',
        UUID: 'C15ED93851B01FA47F9C3D8D11EA225A',
    },
    {
        code: 'PRT',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'PT',
        isoCode3: 'PRT',
        name: 'Portugal',
        UUID: '2D0F2A87A9FC6FDA3C4B49A293933130',
    },
    {
        code: 'PRI',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'PR',
        isoCode3: 'PRI',
        name: 'Puerto Rico',
        UUID: 'EC1EE30C91E0FADF19E62CEC4883DFE0',
    },
    {
        code: 'QAT',
        currencyCode: 'QAR',
        isGDPRFlagged: false,
        isoCode2: 'QA',
        isoCode3: 'QAT',
        name: 'Qatar',
        UUID: 'C0E49B3F4FC3BF65D40D85CE826215D7',
    },
    {
        code: 'SRB',
        currencyCode: 'RSD',
        isGDPRFlagged: false,
        isoCode2: 'RS',
        isoCode3: 'SRB',
        name: 'Serbia',
        UUID: '8BBDEC1C8F59437A84FB9F59FA05638E',
    },
    {
        code: 'REU',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'RE',
        isoCode3: 'REU',
        name: 'Réunion',
        UUID: '785CF8F7A0DFE6A76858AA2A2A212044',
    },
    {
        code: 'ROM',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'RO',
        isoCode3: 'ROU',
        name: 'Romania',
        UUID: '47E6CD09395645AEF1C9CB951B6BEF25',
    },
    {
        code: 'RUS',
        currencyCode: 'RUB',
        isGDPRFlagged: false,
        isoCode2: 'RU',
        isoCode3: 'RUS',
        name: 'Russian Federation',
        UUID: '3E3F545EE955CF5138692DC9B3E4E2CB',
    },
    {
        code: 'RWA',
        currencyCode: 'RWF',
        isGDPRFlagged: false,
        isoCode2: 'RW',
        isoCode3: 'RWA',
        name: 'Rwanda',
        UUID: 'ACDEB7E9B8869013165848384AA96534',
    },
    {
        code: 'KNA',
        currencyCode: 'XCD',
        isGDPRFlagged: false,
        isoCode2: 'KN',
        isoCode3: 'KNA',
        name: 'Saint Kitts And Nevis',
        UUID: '4075A0C98C1DE5947E572C0E723361C6',
    },
    {
        code: 'LCA',
        currencyCode: 'XCD',
        isGDPRFlagged: false,
        isoCode2: 'LC',
        isoCode3: 'LCA',
        name: 'Saint Lucia',
        UUID: '99E4F1B58FB2CE2B10B93F8E21616B97',
    },
    {
        code: 'VCT',
        currencyCode: 'XCD',
        isGDPRFlagged: false,
        isoCode2: 'VC',
        isoCode3: 'VCT',
        name: 'Saint Vincent/Grenadines',
        UUID: '533F746EF7B20166955653DF2CDF9BD3',
    },
    {
        code: 'WSM',
        currencyCode: 'WST',
        isGDPRFlagged: false,
        isoCode2: 'WS',
        isoCode3: 'WSM',
        name: 'Samoa',
        UUID: '0375F36A6AE80C89C9956F83E151D64D',
    },
    {
        code: 'SMR',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'SM',
        isoCode3: 'SMR',
        name: 'San Marino',
        UUID: '1DCDD3AB66DFF801BA637407EAC0236D',
    },
    {
        code: 'STP',
        currencyCode: 'STD',
        isGDPRFlagged: false,
        isoCode2: 'ST',
        isoCode3: 'STP',
        name: 'Sao Tome/Principe Dobra',
        UUID: '29B76CA2494EE8B9A34783FA3663DD0F',
    },
    {
        code: 'SAU',
        currencyCode: 'SAR',
        isGDPRFlagged: false,
        isoCode2: 'SA',
        isoCode3: 'SAU',
        name: 'Saudi Arabia',
        UUID: '563ADB49851489CCB999A660C6DC5F29',
    },
    {
        code: 'SEN',
        currencyCode: 'XOF',
        isGDPRFlagged: false,
        isoCode2: 'SN',
        isoCode3: 'SEN',
        name: 'Senegal',
        UUID: 'D593CACB17FCFE63D5B0DF7C1A2B49C0',
    },
    {
        code: 'SYC',
        currencyCode: 'SCR',
        isGDPRFlagged: false,
        isoCode2: 'SC',
        isoCode3: 'SYC',
        name: 'Seychelles',
        UUID: '3DE77632BC41D0D476A6697229ECD3A0',
    },
    {
        code: 'SLE',
        currencyCode: 'SLL',
        isGDPRFlagged: false,
        isoCode2: 'SL',
        isoCode3: 'SLE',
        name: 'Sierra Leones',
        UUID: '421CAED6B72B1B329AF7D0AEE39859A3',
    },
    {
        code: 'SGP',
        currencyCode: 'SGD',
        isGDPRFlagged: false,
        isoCode2: 'SG',
        isoCode3: 'SGP',
        name: 'Singapore',
        UUID: '937BBFCEE47F062F41671C7304C3D393',
    },
    {
        code: 'SVK',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'SK',
        isoCode3: 'SVK',
        name: 'Slovakia',
        UUID: '932A549DC1FD5F4B9AA91F9528C97A7D',
    },
    {
        code: 'SVN',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'SI',
        isoCode3: 'SVN',
        name: 'Slovenia',
        UUID: 'F2F8B4D6549812FA20B05D68C387BCD4',
    },
    {
        code: 'SLB',
        currencyCode: 'SBD',
        isGDPRFlagged: false,
        isoCode2: 'SB',
        isoCode3: 'SLB',
        name: 'Solomon Islands',
        UUID: '945071BD6AAFDD568C236A14B8DBDCAC',
    },
    {
        code: 'SOM',
        currencyCode: 'SOS',
        isGDPRFlagged: false,
        isoCode2: 'SO',
        isoCode3: 'SOM',
        name: 'Somalia',
        UUID: '925251B7C491B5E3E2C03966B56AAF9C',
    },
    {
        code: 'ZAF',
        currencyCode: 'ZAR',
        isGDPRFlagged: false,
        isoCode2: 'ZA',
        isoCode3: 'ZAF',
        name: 'South Africa',
        UUID: 'C67C7930456C0677730324C5FB0D5574',
    },
    {
        code: 'SGS',
        currencyCode: 'FKP',
        isGDPRFlagged: false,
        isoCode2: 'GS',
        isoCode3: 'SGS',
        name: 'South Georgia/South Sandwich Is',
        UUID: '5F15610A29E8790CDF1FB67D833CCA1D',
    },
    {
        code: 'ESP',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'ES',
        isoCode3: 'ESP',
        name: 'Spain',
        UUID: '0A65C04B2DFF6672BF55CC28B9A384E4',
    },
    {
        code: 'LKA',
        currencyCode: 'LKR',
        isGDPRFlagged: false,
        isoCode2: 'LK',
        isoCode3: 'LKA',
        name: 'Sri Lanka',
        UUID: 'D864F7F4FEC4E48E632235978F9A4BA1',
    },
    {
        code: 'SHN',
        currencyCode: 'SHP',
        isGDPRFlagged: false,
        isoCode2: 'SH',
        isoCode3: 'SHN',
        name: 'St Helena',
        UUID: 'C8D5AF1C333550847E4DA8E0512250CF',
    },
    {
        code: 'SPM',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'PM',
        isoCode3: 'SPM',
        name: 'St Pierre and Miquelon',
        UUID: '531B06F3DF3E32F537E663C5C2AD0A7A',
    },
    {
        code: 'SDN',
        currencyCode: 'SDG',
        isGDPRFlagged: false,
        isoCode2: 'SD',
        isoCode3: 'SDN',
        name: 'Sudan',
        UUID: '19B51854566609E331D067746F24CFC7',
    },
    {
        code: 'SUR',
        currencyCode: 'SRD',
        isGDPRFlagged: false,
        isoCode2: 'SR',
        isoCode3: 'SUR',
        name: 'Suriname',
        UUID: 'BFF9B66FD84A4D310D9D853A11D11951',
    },
    {
        code: 'SJM',
        currencyCode: 'NOK',
        isGDPRFlagged: false,
        isoCode2: 'SJ',
        isoCode3: 'SJM',
        name: 'Svalbard/Jan Mayen Islands',
        UUID: 'F98E827A428D568066CF576C63DFAB9D',
    },
    {
        code: 'SWZ',
        currencyCode: 'SZL',
        isGDPRFlagged: false,
        isoCode2: 'SZ',
        isoCode3: 'SWZ',
        name: 'Swaziland',
        UUID: '5A3009F755E36CF706225752360AB42A',
    },
    {
        code: 'SWE',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'SE',
        isoCode3: 'SWE',
        name: 'Sweden',
        UUID: '92053F5C61AE8EA191F73C8F76B09723',
    },
    {
        code: 'CHE',
        currencyCode: 'CHF',
        isGDPRFlagged: false,
        isoCode2: 'CH',
        isoCode3: 'CHE',
        name: 'Switzerland',
        UUID: '9C1389D199BA5129CECCE7E5021CF21F',
    },
    {
        code: 'SYR',
        currencyCode: 'SYP',
        isGDPRFlagged: false,
        isoCode2: 'SY',
        isoCode3: 'SYR',
        name: 'Syrian Arab Republic',
        UUID: '66E764E93025AB4C3E7E07D1F1DEFD1D',
    },
    {
        code: 'TWN',
        currencyCode: 'TWD',
        isGDPRFlagged: false,
        isoCode2: 'TW',
        isoCode3: 'TWN',
        name: 'Taiwan',
        UUID: '341CA4B0DEF32A1FCB0CE0C7DACC93F5',
    },
    {
        code: 'TJK',
        currencyCode: 'TJS',
        isGDPRFlagged: false,
        isoCode2: 'TJ',
        isoCode3: 'TJK',
        name: 'Tajikistan',
        UUID: '1317E8919A9D402E3C200FFD86267712',
    },
    {
        code: 'TZA',
        currencyCode: 'TZS',
        isGDPRFlagged: false,
        isoCode2: 'TZ',
        isoCode3: 'TZA',
        name: 'Tanzania United Republic of',
        UUID: '61C2D8041DFD02D22F343344E93380EF',
    },
    {
        code: 'THA',
        currencyCode: 'THB',
        isGDPRFlagged: false,
        isoCode2: 'TH',
        isoCode3: 'THA',
        name: 'Thailand',
        UUID: '6F3AD03A82192DE19945C19C9CB48985',
    },
    {
        code: 'TGO',
        currencyCode: 'XOF',
        isGDPRFlagged: false,
        isoCode2: 'TG',
        isoCode3: 'TGO',
        name: 'Togo',
        UUID: 'DE7A6C6FB3E874DA97BBF758F436E5C5',
    },
    {
        code: 'TKL',
        currencyCode: 'NZD',
        isGDPRFlagged: false,
        isoCode2: 'TK',
        isoCode3: 'TKL',
        name: 'Tokelau',
        UUID: '1A98A83843D0A6D77707A75E817339E6',
    },
    {
        code: 'TON',
        currencyCode: 'TOP',
        isGDPRFlagged: false,
        isoCode2: 'TO',
        isoCode3: 'TON',
        name: 'Tonga',
        UUID: 'B9FC1D4C8993953EE1862B8CC0E86630',
    },
    {
        code: 'TTO',
        currencyCode: 'TTD',
        isGDPRFlagged: false,
        isoCode2: 'TT',
        isoCode3: 'TTO',
        name: 'Trinidad and Tobago',
        UUID: 'B660BCD2E1AD5C4B03FE0887B51E27BC',
    },
    {
        code: 'TUN',
        currencyCode: 'TND',
        isGDPRFlagged: false,
        isoCode2: 'TN',
        isoCode3: 'TUN',
        name: 'Tunisia',
        UUID: 'F8CF559A397F2E631649C88AA6C05645',
    },
    {
        code: 'TUR',
        currencyCode: 'TRY',
        isGDPRFlagged: false,
        isoCode2: 'TR',
        isoCode3: 'TUR',
        name: 'Turkey',
        UUID: '4746359F7DCCDC9B63202CD27A3BBF1B',
    },
    {
        code: 'TKM',
        currencyCode: 'TMM',
        isGDPRFlagged: false,
        isoCode2: 'TM',
        isoCode3: 'TKM',
        name: 'Turkmenistan',
        UUID: 'E88913AEC66FE82831F5053B388FE929',
    },
    {
        code: 'TCA',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'TC',
        isoCode3: 'TCA',
        name: 'Turks And Caicos Islands',
        UUID: '3F208D9A3E0D2524C5A0405AC76987FF',
    },
    {
        code: 'TUV',
        currencyCode: 'AUD',
        isGDPRFlagged: false,
        isoCode2: 'TV',
        isoCode3: 'TUV',
        name: 'Tuvalu',
        UUID: '8211CC0E292EF452F6C3DECEF511BE94',
    },
    {
        code: 'UGA',
        currencyCode: 'UGX',
        isGDPRFlagged: false,
        isoCode2: 'UG',
        isoCode3: 'UGA',
        name: 'Uganda',
        UUID: '21B3F739AE1A6A5A1F373D8767422E62',
    },
    {
        code: 'UKR',
        currencyCode: 'UAH',
        isGDPRFlagged: false,
        isoCode2: 'UA',
        isoCode3: 'UKR',
        name: 'Ukraine',
        UUID: 'A68FF4F271E242EFA1274CE988E13844',
    },
    {
        code: 'ARE',
        currencyCode: 'AED',
        isGDPRFlagged: false,
        isoCode2: 'AE',
        isoCode3: 'ARE',
        name: 'United Arab Emirates',
        UUID: 'CFEB040066A20AC7174049FEFAE20971',
    },
    {
        code: 'GBR',
        currencyCode: 'GBP',
        isGDPRFlagged: false,
        isoCode2: 'GB',
        isoCode3: 'GBR',
        name: 'United Kingdom',
        UUID: '7732BFB301F5F70251A86FEBE44F7B82',
    },
    {
        code: 'USA',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'US',
        isoCode3: 'USA',
        name: 'United States',
        UUID: '09D1B8CA66D5DA175231C22413609DA4',
    },
    {
        code: 'XX',
        currencyCode: '',
        isGDPRFlagged: false,
        isoCode2: 'XX',
        isoCode3: 'XXX',
        name: 'Unknown',
        UUID: 'F7DA897F0C6BD3F6C350ABC980919CB4',
    },
    {
        code: 'URY',
        currencyCode: 'UYU',
        isGDPRFlagged: false,
        isoCode2: 'UY',
        isoCode3: 'URY',
        name: 'Uruguay',
        UUID: '337726ED646FB1A36CC7A62C60F652C6',
    },
    {
        code: 'UMI',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'UM',
        isoCode3: 'UMI',
        name: 'US Minor Outlying Islands',
        UUID: 'E889F4062C1A815FAD9C59762BD0F74F',
    },
    {
        code: 'UZB',
        currencyCode: 'UZS',
        isGDPRFlagged: false,
        isoCode2: 'UZ',
        isoCode3: 'UZB',
        name: 'Uzbekistan',
        UUID: 'A576DFB1833295FF917B18F52CD7CEF6',
    },
    {
        code: 'VUT',
        currencyCode: 'VUV',
        isGDPRFlagged: false,
        isoCode2: 'VU',
        isoCode3: 'VUT',
        name: 'Vanuatu',
        UUID: 'B7036C319EC4A20303F10385CC9441CB',
    },
    {
        code: 'VAT',
        currencyCode: 'EUR',
        isGDPRFlagged: false,
        isoCode2: 'VA',
        isoCode3: 'VAT',
        name: 'Vatican City State',
        UUID: 'E873044801337EC43AB02E1D0017D57C',
    },
    {
        code: 'VEN',
        currencyCode: 'VEF',
        isGDPRFlagged: false,
        isoCode2: 'VE',
        isoCode3: 'VEN',
        name: 'Venezuela',
        UUID: 'E07EE2274FAA21961F512C73B8058EE9',
    },
    {
        code: 'VNM',
        currencyCode: 'VND',
        isGDPRFlagged: false,
        isoCode2: 'VN',
        isoCode3: 'VNM',
        name: 'Viet Nam',
        UUID: '0FDE9767258FB44247D26284072617EB',
    },
    {
        code: 'VGB',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'VG',
        isoCode3: 'VGB',
        name: 'Virgin Islands British',
        UUID: '55DDD2066F5C6F615D4277226E157C23',
    },
    {
        code: 'VIR',
        currencyCode: 'USD',
        isGDPRFlagged: false,
        isoCode2: 'VI',
        isoCode3: 'VIR',
        name: 'Virgin Islands US',
        UUID: '3130BE5FACF944445A0BC38C733C2C99',
    },
    {
        code: 'WLF',
        currencyCode: 'XPF',
        isGDPRFlagged: false,
        isoCode2: 'WF',
        isoCode3: 'WLF',
        name: 'Wallis/Futuna Islands',
        UUID: '9FADC4F16BB98ABC1C236BDA80E2D2CC',
    },
    {
        code: 'ESH',
        currencyCode: 'MAD',
        isGDPRFlagged: false,
        isoCode2: 'EH',
        isoCode3: 'ESH',
        name: 'Western Sahara',
        UUID: 'AA78EA92F1018994DC5C9B7966212F9A',
    },
    {
        code: 'YEM',
        currencyCode: 'YER',
        isGDPRFlagged: false,
        isoCode2: 'YD',
        isoCode3: 'YEM',
        name: 'Yemen',
        UUID: '07E2700B6BB83992275C2147CFDB4823',
    },
    {
        code: 'ZMB',
        currencyCode: 'ZMW',
        isGDPRFlagged: false,
        isoCode2: 'ZM',
        isoCode3: 'ZMB',
        name: 'Zambia',
        UUID: '10517E039A685612BAB34CC1E13E590C',
    },
    {
        code: 'ZWE',
        currencyCode: 'ZWD',
        isGDPRFlagged: false,
        isoCode2: 'ZW',
        isoCode3: 'ZWE',
        name: 'Zimbabwe',
        UUID: '0BFC7489D27116E94E9FDD390298EFC9',
    },
];
exports.default = exports.countries;
